// Anonymous booking-funnel tracking for the owner's Demand Insights page.
// Sends the property address once the address step is passed, then the
// furthest step reached. Never blocks or breaks booking.

const STORAGE_KEY = 'ma_booking_funnel_token';
const ATTRIBUTION_KEY = 'ma_booking_attribution';

const newToken = () => {
  try { if (window.crypto?.randomUUID) return window.crypto.randomUUID(); } catch (e) {}
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
};

// Remember where the visitor first came from in this tab (ad click, UTM tags).
const attribution = () => {
  try {
    const saved = sessionStorage.getItem(ATTRIBUTION_KEY);
    if (saved) return JSON.parse(saved);
    const q = new URLSearchParams(window.location.search);
    const fromAd = !!(q.get('gclid') || q.get('gbraid') || q.get('wbraid') || q.get('fbclid') || q.get('utm_medium') === 'cpc');
    let referrerHost = '';
    try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    const data = {
      source: q.get('utm_source') || (q.get('gclid') ? 'google' : q.get('fbclid') ? 'facebook' : (referrerHost && !referrerHost.includes('modernangles.com') ? referrerHost : '')),
      medium: q.get('utm_medium') || '',
      campaign: q.get('utm_campaign') || '',
      from_ad: fromAd,
      landing_page: window.location.pathname
    };
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(data));
    return data;
  } catch (e) {
    return {};
  }
};
// Capture on first load, before in-app navigation drops the query string.
try { attribution(); } catch (e) {}

const device = () => (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop');

const currentToken = () => { try { return sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; } };

export const bookingFunnelStart = (flow, state) => {
  try {
    let token = currentToken();
    if (!token) {
      token = newToken();
      sessionStorage.setItem(STORAGE_KEY, token);
    }
    $.ajax({
      type: 'POST', url: '/booking_starts',
      data: {
        token, flow, device: device(), ...attribution(),
        address: {
          formatted_address: state.formatted_address || '', street: state.street || '',
          city: state.city || '', state: state.state || '', zipcode: state.zipcode || ''
        }
      }
    }).catch(() => {});
  } catch (e) {}
};

// cart: { sub_service_ids: [...], cart_total: number } (optional)
export const bookingFunnelStep = (step, cart = {}) => {
  try {
    const token = currentToken();
    if (!token) return;
    const data = { token, step };
    if (cart.sub_service_ids?.length) data.sub_service_ids = cart.sub_service_ids;
    if (Number(cart.cart_total) > 0) data.cart_total = Number(cart.cart_total).toFixed(2);
    $.ajax({ type: 'POST', url: '/booking_starts/step', data }).catch(() => {});
    // A finished booking ends this attempt; the next booking starts fresh.
    if (step === 'booked') sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
};
